module.exports = __webpack_public_path__ + "media/src/shared_components/images/share_icon-1b8bf83b9473f87301e5d76260c1edeb.svg";